import { render, staticRenderFns } from "./borrowerEditAccountDialog.vue?vue&type=template&id=6b5da763&scoped=true&"
import script from "./borrowerEditAccountDialog.vue?vue&type=script&lang=js&"
export * from "./borrowerEditAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./borrowerEditAccountDialog.vue?vue&type=style&index=0&id=6b5da763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5da763",
  null
  
)

export default component.exports